"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Annotation_1 = require("./Annotation");
const BugHole_1 = require("./BugHole");
const Date_1 = require("./Date");
const Furigana_1 = require("./Furigana");
const Illegible_1 = require("./Illegible");
const Kaeriten_1 = require("./Kaeriten");
const Okurigana_1 = require("./Okurigana");
const Person_1 = require("./Person");
const Place_1 = require("./Place");
const Title_1 = require("./Title");
const Warigaki_1 = require("./Warigaki");
const Misekechi_1 = require("./Misekechi");
const Kenten_1 = require("./Kenten");
exports.default = [
    Annotation_1.default,
    BugHole_1.default,
    Date_1.default,
    Furigana_1.default,
    Illegible_1.default,
    Kaeriten_1.default,
    Okurigana_1.default,
    Person_1.default,
    Place_1.default,
    Title_1.default,
    Warigaki_1.default,
    Misekechi_1.default,
    Kenten_1.default
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZDQUFzQztBQUN0Qyx1Q0FBZ0M7QUFDaEMsaUNBQTBCO0FBQzFCLHlDQUFrQztBQUNsQywyQ0FBb0M7QUFFcEMseUNBQWtDO0FBQ2xDLDJDQUFvQztBQUNwQyxxQ0FBOEI7QUFDOUIsbUNBQTRCO0FBQzVCLG1DQUE0QjtBQUM1Qix5Q0FBa0M7QUFDbEMsMkNBQW9DO0FBQ3BDLHFDQUE4QjtBQUU5QixrQkFBZTtJQUNkLG9CQUFVO0lBQ1YsaUJBQU87SUFDUCxjQUFJO0lBQ0osa0JBQVE7SUFDUixtQkFBUztJQUNULGtCQUFRO0lBQ1IsbUJBQVM7SUFDVCxnQkFBTTtJQUNOLGVBQUs7SUFDTCxlQUFLO0lBQ0wsa0JBQVE7SUFDUixtQkFBUztJQUNULGdCQUFNO0NBQ04sQ0FBQyJ9